import React from 'react';
import { LanguageIndicator } from '../LanguageIndicator';
import { CopyButton } from '../CopyButton';
import { SyntaxHighlighter } from '../SyntaxHighlighter';

export interface CodeBlockProps {
  children: React.ReactNode;
  language?: string;
  className?: string;
}

const CodeBlock: React.FC<CodeBlockProps> = ({ 
  children, 
  language, 
  className = '' 
}) => {
  const extractTextContent = (node: React.ReactNode): string => {
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (React.isValidElement(node)) {
      if (node.props.children) {
        return extractTextContent(node.props.children);
      }
    }
    if (Array.isArray(node)) {
      return node.map(extractTextContent).join('');
    }
    return '';
  };

  const handleCopy = async () => {
    const textContent = extractTextContent(children);
    await navigator.clipboard.writeText(textContent);
  };

  const code = extractTextContent(children);

  return (
    <div className={`relative group ${className}`}>
      {/* Language indicator */}
      {language && <LanguageIndicator language={language} />}

      {/* Copy button */}
      <CopyButton onCopy={handleCopy} />

      {/* Syntax highlighted code */}
      <SyntaxHighlighter 
        code={code} 
        language={language || 'text'} 
        className="blog-content-pre"
      />
    </div>
  );
};

export default CodeBlock;